import { createRouter, createWebHashHistory } from 'vue-router'

// 校验用户本地登录状态,未登录跳转到登录
function isLogined() {
    const TK = localStorage.getItem("tk");

    if (!TK) {
      return { name: "login" };
    }
}

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login.vue')
  },
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home.vue'),
    beforeEnter: [isLogined],
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
